import Axios from 'axios';

import {AuthCredentials, LoginResponseBody} from './types';
import {Base64} from 'js-base64';
import {getAPIEndpoint} from 'api/utils';
import {ApiError} from 'api/error';

export const login = async (creds: AuthCredentials) => {
  const {email, password} = creds;
  const base64EncodedCredentials = Base64.encode(`${email}:${password}`);

  const requestUrl = getAPIEndpoint('authentication/login');
  const headers = {
    Authorization: `Basic ${base64EncodedCredentials}`,
  };

  const res = await Axios.post(requestUrl, creds, {headers});

  switch (true) {
    // If OK
    case res.status >= 200 && res.status < 300:
      return res.data as LoginResponseBody;
    default:
      throw new ApiError(res.data);
  }
};

export const refreshToken = async (refreshToken: string) => {
  if (!refreshToken) {
    throw new Error('No refresh token, exiting.');
  }

  const requestUrl = getAPIEndpoint('refresh');
  const headers = {
    Authorization: `Bearer ${refreshToken}`,
  };

  const res = await Axios.post(requestUrl, '', {headers});

  switch (true) {
    case res.status >= 200 && res.status < 300:
      return res.data as LoginResponseBody;
    default:
      throw new ApiError(res.data);
  }
};

/**
 * Sends request to the password reset endpoint.
 * @param email Email to request password reset for.
 */
export const resetPassword = async (email: string) => {
  const encodedEmail = encodeURIComponent(email);
  const requestUrl = getAPIEndpoint(
    `authentication/requestPasswordReset?email=${encodedEmail}`
  );
  return await Axios.post(requestUrl);
};

export const confirmPasswordReset = async (
  id: string,
  password: string,
  token: string
) => {
  const requestUrl = getAPIEndpoint('/authentication/resetPassword');
  return await Axios.post(requestUrl, {id, password, token});
};
